let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("20Ey1")).then(() => parcelRequire('7mhty'));